<template>
  <div id="nextPage" class="nextPage">
    <div class="npText">
      <h2>{{ page }}</h2>
      <h4>next</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: "nextPage",
  props: {
    page: String,
    color: String
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/componentStyles/nextPage.scss";
</style>
